// PrematchTournament
import React, { useEffect, useMemo } from 'react';
import cx from 'classnames';
import { CDN_TYPE_SPORT, getCDNUrl } from 'utils';

import { SiteConfigManager, TournamentProvider, usePreferences } from '@atlas/core';
import { Flag } from '@atlas/ui';

import MenuItemFavoriteExpand from 'common/MenuItem/MenuItemFavoriteExpand';
import useIsLivePage from 'components/Sportsbook/useIsLivePage';

import { TournamentOutrights } from '../TournamentOutrights';
import { TournamentScrollGrid } from '../TournamentScrollGrid';
import { TournamentSwipeGrid } from '../TournamentSwipeGrid';

import TournamentLoader from './TournamentLoader';

export const PrematchTournament = ({
  clickedCategory,
  expandedCategory,
  forceIsExpanded = false,
  hasSportFormMainTypes,
  isFavoriteList = false,
  marketTypesPeriodMap,
  onEventClick,
  tournament,
}) => {
  const { categoryId, categoryName, id, imagePaths, name } = tournament;
  const imagePath = imagePaths?.FLAG;

  const collapseTournaments = SiteConfigManager.getConfig(
    'config.config.sportsbook.mobileCollapseTournaments',
  );
  const isLive = useIsLivePage();
  const [isExpanded, setIsExpanded] = React.useState(
    isLive || (forceIsExpanded && !collapseTournaments),
  );

  const { getIsTournamentFavorite, selectFavoriteTournament } = usePreferences();
  const isTournamentFavorite = !isFavoriteList && !!getIsTournamentFavorite({ tournamentId: id });

  const selectFavoriteTournamentHandler = () => {
    selectFavoriteTournament({ tournamentId: id });
  };

  useEffect(() => {
    if (clickedCategory === categoryId) {
      setIsExpanded(false);
    }
  }, [expandedCategory]);

  const toggleExpanded = React.useCallback(() => {
    setIsExpanded(prevIsExpanded => !prevIsExpanded);
  }, []);

  const headerClassName = cx('tournament-header-info', { active: isExpanded });

  const TournamentGridComponent = React.useMemo(() => {
    // TODO: Remove config usage from tournament component
    const mobileGridViewType = SiteConfigManager.getConfig(
      'config.config.sportsbook.mobileGridViewType',
    );

    if (mobileGridViewType === 'swipe') {
      return TournamentSwipeGrid;
    }

    return TournamentScrollGrid;
  }, []);

  const mainLabel = useMemo(() => {
    if (isLive) {
      return `${categoryName}, ${name}`;
    }
    return name;
  }, [isLive, categoryName, name]);

  return (
    <div className="tournament tournament-scroll">
      <div className={headerClassName}>
        <MenuItemFavoriteExpand
          dataTestId="tournament"
          dataTestItemId={tournament.id}
          icon={
            <Flag
              alt={name}
              cdnHostname={getCDNUrl(CDN_TYPE_SPORT)}
              imagePath={imagePath}
              name={tournament.id}
            />
          }
          isExpanded={isExpanded}
          isFavorite={isTournamentFavorite}
          mainLabel={mainLabel}
          setFavorite={selectFavoriteTournamentHandler}
          toggleExpanded={toggleExpanded}
        />
      </div>

      {isExpanded && (
        <TournamentProvider key={id} tournament={tournament}>
          <TournamentLoader>
            <TournamentGridComponent
              hasSportFormMainTypes={hasSportFormMainTypes}
              hideMarketTypeHeaders
              hideOutcomeTypeHeaders
              marketTypeClassName="col"
              marketTypesPeriodMap={marketTypesPeriodMap}
              onEventClick={onEventClick}
            />
            <TournamentOutrights />
          </TournamentLoader>
        </TournamentProvider>
      )}
    </div>
  );
};
